export interface GrowlersCashbackConfig {
  enabled: boolean;
  /** Percentual creditado sobre o subtotal dos itens (sem frete). */
  earnPercent: number;
  /** Percentual do saldo que pode ser usado em cada compra. */
  redeemPercentPerOrder: number;
}

export const DEFAULT_GROWLERS_CASHBACK_CONFIG: GrowlersCashbackConfig = {
  enabled: false,
  earnPercent: 0,
  redeemPercentPerOrder: 0,
};

export const GROWLERS_CASHBACK_DOC_ID = 'growlers_cashback';

export interface CashbackWallet {
  email: string;
  uid: string;
  balance: number;
  cpf?: string;
}
